/* eslint-disable menti-react/filename-convention--jsx */
import { greenhouse } from '@mentimeter/sfinx-themes';
import { useOptionalPace } from '../../data-mediation';

const C = greenhouse.background;

export const GreenhouseBackground = () => {
  const slideIndex = useOptionalPace()?.state?.slideIndex ?? 0;
  const progress = useOptionalPace()?.selectors?.progress?.() ?? 0;
  return <C progress={progress} currentIndex={slideIndex} />;
};
